var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconId = function SvgIconId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FFBB5C",
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.064 8v8H6V8h2.064ZM13.223 16h-3.46V8h3.489c.982 0 1.827.16 2.536.48.709.318 1.254.775 1.635 1.372.385.596.577 1.31.577 2.14 0 .833-.192 1.55-.577 2.149-.381.599-.93 1.058-1.644 1.379-.712.32-1.564.48-2.556.48Zm-1.396-1.45h1.31c.61 0 1.124-.088 1.54-.265.42-.18.735-.457.944-.832.213-.377.32-.864.32-1.46 0-.592-.107-1.075-.32-1.45a1.886 1.886 0 0 0-.939-.828c-.416-.177-.93-.266-1.54-.266h-1.315v5.102Z"
  }))));
};
export default SvgIconId;